import { ReactComponent as ArrowUpL } from '../../images/icon-components/main-set/arrow-up/32.svg'
import { ReactComponent as ArrowUpM } from '../../images/icon-components/main-set/arrow-up/24.svg'
import { ReactComponent as ArrowUpS } from '../../images/icon-components/main-set/arrow-up/16.svg'

import { ReactComponent as ArrowDownL } from '../../images/icon-components/main-set/arrow-down/32.svg'
import { ReactComponent as ArrowDownM } from '../../images/icon-components/main-set/arrow-down/24.svg'
import { ReactComponent as ArrowDownS } from '../../images/icon-components/main-set/arrow-down/16.svg'

import { ReactComponent as ArrowRounded } from '../../images/icon-components/main-set/arrow-rounded/arrow.svg'

import { ReactComponent as Arrow1LeftL } from '../../images/icon-components/main-set/arrow1-left/32.svg'
import { ReactComponent as Arrow1LeftM } from '../../images/icon-components/main-set/arrow1-left/24.svg'
import { ReactComponent as Arrow1LeftS } from '../../images/icon-components/main-set/arrow1-left/16.svg'

import { ReactComponent as Arrow1DownL } from '../../images/icon-components/main-set/arrow1-down/32.svg'
import { ReactComponent as Arrow1DownM } from '../../images/icon-components/main-set/arrow1-down/24.svg'
import { ReactComponent as Arrow1DownS } from '../../images/icon-components/main-set/arrow1-down/16.svg'

import { ReactComponent as Arrow1RightL } from '../../images/icon-components/main-set/arrow1-right/32.svg'
import { ReactComponent as Arrow1RightM } from '../../images/icon-components/main-set/arrow1-right/24.svg'
import { ReactComponent as Arrow1RightS } from '../../images/icon-components/main-set/arrow1-right/16.svg'

import { ReactComponent as Arrow2BigL } from '../../images/icon-components/main-set/arrow2-big/32.svg'
import { ReactComponent as Arrow2BigM } from '../../images/icon-components/main-set/arrow2-big/24.svg'
import { ReactComponent as Arrow2BigS } from '../../images/icon-components/main-set/arrow2-big/16.svg'

import { ReactComponent as Arrow2SmallL } from '../../images/icon-components/main-set/arrow2-small/32.svg'
import { ReactComponent as Arrow2SmallM } from '../../images/icon-components/main-set/arrow2-small/24.svg'
import { ReactComponent as Arrow2SmallS } from '../../images/icon-components/main-set/arrow2-small/16.svg'

import { ReactComponent as ArrowLeft } from '../../images/icon-components/main-set/arrow-left/24.svg'
import { ReactComponent as ArrowRight } from '../../images/icon-components/main-set/arrow-right/24.svg'
import { ReactComponent as ArrowPrevious } from '../../images/icon-components/main-set/arrow-previous/24.svg'
import { ReactComponent as ArrowNext } from '../../images/icon-components/main-set/arrow-next/24.svg'

import { ReactComponent as ArrowLineUp } from '../../images/icon-components/main-set/arrow-lineup/24.svg'
import { ReactComponent as ArrowLineDown } from '../../images/icon-components/main-set/arrow-linedown/24.svg'

import { ReactComponent as Avatar1S } from '../../images/icon-components/main-set/avatar1/16.svg'
import { ReactComponent as Avatar1M } from '../../images/icon-components/main-set/avatar1/24.svg'
import { ReactComponent as Avatar1L } from '../../images/icon-components/main-set/avatar1/32.svg'

import { ReactComponent as AttachS } from '../../images/icon-components/main-set/attach/16.svg'
import { ReactComponent as AttachM } from '../../images/icon-components/main-set/attach/24.svg'
import { ReactComponent as AttachL } from '../../images/icon-components/main-set/attach/32.svg'

import { ReactComponent as PhotoS } from '../../images/icon-components/main-set/photo/16.svg'
import { ReactComponent as PhotoM } from '../../images/icon-components/main-set/photo/24.svg'
import { ReactComponent as PhotoL } from '../../images/icon-components/main-set/photo/32.svg'

import { ReactComponent as SmileS } from '../../images/icon-components/main-set/smile/16.svg'
import { ReactComponent as SmileM } from '../../images/icon-components/main-set/smile/24.svg'
import { ReactComponent as SmileL } from '../../images/icon-components/main-set/smile/32.svg'

import { ReactComponent as Avatar2L } from '../../images/icon-components/main-set/avatar2/32.svg'
import { ReactComponent as Avatar2M } from '../../images/icon-components/main-set/avatar2/24.svg'
import { ReactComponent as Avatar2S } from '../../images/icon-components/main-set/avatar2/16.svg'

import { ReactComponent as Back } from '../../images/icon-components/main-set/back/32.svg'
import { ReactComponent as Bell } from '../../images/icon-components/main-set/bell/32.svg'
import { ReactComponent as Bonus } from '../../images/icon-components/main-set/bonus/32.svg'
import { ReactComponent as Burger } from '../../images/icon-components/main-set/burger/24.svg'

import { ReactComponent as Calendar } from '../../images/icon-components/main-set/calendar/32.svg'
import { ReactComponent as Category } from '../../images/icon-components/main-set/category/32.svg'
import { ReactComponent as Checkmark1 } from '../../images/icon-components/main-set/checkmark1/32.svg'
import { ReactComponent as Checkmark2S } from '../../images/icon-components/main-set/checkmark2/16.svg'
import { ReactComponent as Checkmark2M } from '../../images/icon-components/main-set/checkmark2/24.svg'
import { ReactComponent as Checkmark2L } from '../../images/icon-components/main-set/checkmark2/32.svg'

import { ReactComponent as ClientsS } from '../../images/icon-components/main-set/clients/16.svg'
import { ReactComponent as ClientsM } from '../../images/icon-components/main-set/clients/24.svg'
import { ReactComponent as ClientsL } from '../../images/icon-components/main-set/clients/32.svg'

import { ReactComponent as CloseS } from '../../images/icon-components/main-set/close/16.svg'
import { ReactComponent as CloseM } from '../../images/icon-components/main-set/close/24.svg'
import { ReactComponent as CloseL } from '../../images/icon-components/main-set/close/32.svg'

import { ReactComponent as CopyLinkS } from '../../images/icon-components/main-set/copy-link/16.svg'
import { ReactComponent as CopyLinkM } from '../../images/icon-components/main-set/copy-link/24.svg'
import { ReactComponent as CopyLinkL } from '../../images/icon-components/main-set/copy-link/32.svg'

import { ReactComponent as CopyM } from '../../images/icon-components/main-set/copy/24.svg'

import { ReactComponent as CommentsS } from '../../images/icon-components/main-set/comments/16.svg'
import { ReactComponent as CommentsM } from '../../images/icon-components/main-set/comments/24.svg'
import { ReactComponent as CommentsL } from '../../images/icon-components/main-set/comments/32.svg'

import { ReactComponent as Doc } from '../../images/icon-components/main-set/doc/32.svg'
import { ReactComponent as Dot } from '../../images/icon-components/main-set/dot/32.svg'
import { ReactComponent as Download } from '../../images/icon-components/main-set/download/32.svg'
import { ReactComponent as DropdownMenuS } from '../../images/icon-components/main-set/dropdown-menu/16.svg'
import { ReactComponent as DropdownMenuM } from '../../images/icon-components/main-set/dropdown-menu/24.svg'
import { ReactComponent as DropdownMenuL } from '../../images/icon-components/main-set/dropdown-menu/32.svg'

import { ReactComponent as Filter } from '../../images/icon-components/main-set/filter/32.svg'
import { ReactComponent as Filter2S } from '../../images/icon-components/main-set/filter2/16.svg'
import { ReactComponent as Filter2M } from '../../images/icon-components/main-set/filter2/24.svg'
import { ReactComponent as Filter2L } from '../../images/icon-components/main-set/filter2/32.svg'

import { ReactComponent as FileXls } from '../../images/icon-components/main-set/file-xls/24.svg'

import { ReactComponent as Lightning } from '../../images/icon-components/main-set/lightning/32.svg'

import { ReactComponent as LikeS } from '../../images/icon-components/main-set/like/16.svg'
import { ReactComponent as LikeM } from '../../images/icon-components/main-set/like/24.svg'
import { ReactComponent as LikeL } from '../../images/icon-components/main-set/like/32.svg'

import { ReactComponent as ListS } from '../../images/icon-components/main-set/list/16.svg'
import { ReactComponent as ListM } from '../../images/icon-components/main-set/list/24.svg'
import { ReactComponent as ListL } from '../../images/icon-components/main-set/list/32.svg'

import { ReactComponent as LogoS } from '../../images/icon-components/main-set/logo/16.svg'
import { ReactComponent as LogoM } from '../../images/icon-components/main-set/logo/24.svg'
import { ReactComponent as LogoL } from '../../images/icon-components/main-set/logo/32.svg'
import { ReactComponent as LogoXL } from '../../images/icon-components/main-set/logo/40.svg'

import { ReactComponent as MyAgencyS } from '../../images/icon-components/main-set/my-agency/16.svg'
import { ReactComponent as MyAgencyM } from '../../images/icon-components/main-set/my-agency/24.svg'
import { ReactComponent as MyAgencyL } from '../../images/icon-components/main-set/my-agency/32.svg'

import { ReactComponent as OrdersS } from '../../images/icon-components/main-set/orders/16.svg'
import { ReactComponent as OrdersM } from '../../images/icon-components/main-set/orders/24.svg'
import { ReactComponent as OrdersL } from '../../images/icon-components/main-set/orders/32.svg'

import { ReactComponent as PenS } from '../../images/icon-components/main-set/pen/16.svg'
import { ReactComponent as PenM } from '../../images/icon-components/main-set/pen/24.svg'
import { ReactComponent as PenL } from '../../images/icon-components/main-set/pen/32.svg'
import { ReactComponent as Platform } from '../../images/icon-components/main-set/platform/32.svg'
import { ReactComponent as Plus } from '../../images/icon-components/main-set/plus/32.svg'

import { ReactComponent as ProxyS } from '../../images/icon-components/main-set/proxy/16.svg'
import { ReactComponent as ProxyM } from '../../images/icon-components/main-set/proxy/24.svg'
import { ReactComponent as ProxyL } from '../../images/icon-components/main-set/proxy/32.svg'

import { ReactComponent as QuestionS } from '../../images/icon-components/main-set/question/16.svg'
import { ReactComponent as QuestionM } from '../../images/icon-components/main-set/question/24.svg'
import { ReactComponent as QuestionL } from '../../images/icon-components/main-set/question/32.svg'

import { ReactComponent as InformationS } from '../../images/icon-components/main-set/information/16.svg'
import { ReactComponent as InformationM } from '../../images/icon-components/main-set/information/24.svg'
import { ReactComponent as InformationL } from '../../images/icon-components/main-set/information/32.svg'

import { ReactComponent as DeleteS } from '../../images/icon-components/main-set/delete/16.svg'
import { ReactComponent as DeleteM } from '../../images/icon-components/main-set/delete/24.svg'
import { ReactComponent as DeleteL } from '../../images/icon-components/main-set/delete/32.svg'

import { ReactComponent as Refresh } from '../../images/icon-components/main-set/refresh/32.svg'

import { ReactComponent as RUBS } from '../../images/icon-components/main-set/currencies/rouble/16.svg'
import { ReactComponent as RUBM } from '../../images/icon-components/main-set/currencies/rouble/24.svg'
import { ReactComponent as RUBL } from '../../images/icon-components/main-set/currencies/rouble/32.svg'

import { ReactComponent as Search } from '../../images/icon-components/main-set/search/32.svg'

import { ReactComponent as ShareS } from '../../images/icon-components/main-set/share/16.svg'
import { ReactComponent as ShareM } from '../../images/icon-components/main-set/share/24.svg'
import { ReactComponent as ShareL } from '../../images/icon-components/main-set/share/32.svg'

import { ReactComponent as Star } from '../../images/icon-components/main-set/star/32.svg'

import { ReactComponent as Stats1S } from '../../images/icon-components/main-set/stats-1/16.svg'
import { ReactComponent as Stats1M } from '../../images/icon-components/main-set/stats-1/24.svg'
import { ReactComponent as Stats1L } from '../../images/icon-components/main-set/stats-1/32.svg'

import { ReactComponent as Stats2 } from '../../images/icon-components/main-set/stats-2/32.svg'

import { ReactComponent as StatusOnS } from '../../images/icon-components/main-set/status-on/16.svg'
import { ReactComponent as StatusOnM } from '../../images/icon-components/main-set/status-on/24.svg'
import { ReactComponent as StatusOnL } from '../../images/icon-components/main-set/status-on/32.svg'

import { ReactComponent as StatusOk } from '../../images/icon-components/main-set/status-ok/status-ok.svg'

import { ReactComponent as StatusPauseS } from '../../images/icon-components/main-set/status-pause/16.svg'
import { ReactComponent as StatusPauseM } from '../../images/icon-components/main-set/status-pause/24.svg'
import { ReactComponent as StatusPauseL } from '../../images/icon-components/main-set/status-pause/32.svg'

import { ReactComponent as StatusPauseCircle } from '../../images/icon-components/main-set/status-pause-circle/24.svg'

import { ReactComponent as StatusBlockedS } from '../../images/icon-components/main-set/status-blocked/16.svg'
import { ReactComponent as StatusBlockedM } from '../../images/icon-components/main-set/status-blocked/24.svg'
import { ReactComponent as StatusBlockedL } from '../../images/icon-components/main-set/status-blocked/32.svg'

import { ReactComponent as StatusFinishedS } from '../../images/icon-components/main-set/status-finished/16.svg'
import { ReactComponent as StatusFinishedM } from '../../images/icon-components/main-set/status-finished/24.svg'
import { ReactComponent as StatusFinishedL } from '../../images/icon-components/main-set/status-finished/32.svg'

import { ReactComponent as StatusArchiveS } from '../../images/icon-components/main-set/status-archive/16.svg'
import { ReactComponent as StatusArchiveM } from '../../images/icon-components/main-set/status-archive/24.svg'
import { ReactComponent as StatusArchiveL } from '../../images/icon-components/main-set/status-archive/32.svg'

import { ReactComponent as StatusActiveRound } from '../../images/icon-components/status/active.svg'
import { ReactComponent as StatusPauseRound } from '../../images/icon-components/status/pause.svg'
import { ReactComponent as StatusBlockRound } from '../../images/icon-components/status/block.svg'
import { ReactComponent as StatusErrorRound } from '../../images/icon-components/status/error.svg'
import { ReactComponent as StatusWarningRound } from '../../images/icon-components/status/warning.svg'
import { ReactComponent as StatusWarningRound2 } from '../../images/icon-components/status/warning2.svg'
import { ReactComponent as Done } from '../../images/icon-components/status/done.svg'
import { ReactComponent as StatusStopRound } from '../../images/icon-components/status/stop.svg'
import { ReactComponent as StatusReadRound } from '../../images/icon-components/status/read.svg'
import { ReactComponent as Spinner } from '../../images/icon-components/main-set/spinner/40.svg'

import { ReactComponent as User } from '../../images/icon-components/main-set/user/24.svg'

import { ReactComponent as Users } from '../../images/icon-components/main-set/users/24.svg'

import { ReactComponent as ViewsS } from '../../images/icon-components/main-set/views/16.svg'
import { ReactComponent as ViewsM } from '../../images/icon-components/main-set/views/24.svg'
import { ReactComponent as ViewsL } from '../../images/icon-components/main-set/views/32.svg'

import { ReactComponent as USDS } from '../../images/icon-components/main-set/currencies/usd/16.svg'
import { ReactComponent as USDM } from '../../images/icon-components/main-set/currencies/usd/24.svg'
import { ReactComponent as USDL } from '../../images/icon-components/main-set/currencies/usd/32.svg'

import { ReactComponent as EURS } from '../../images/icon-components/main-set/currencies/euro/16.svg'
import { ReactComponent as EURM } from '../../images/icon-components/main-set/currencies/euro/24.svg'
import { ReactComponent as EURL } from '../../images/icon-components/main-set/currencies/euro/32.svg'

import { ReactComponent as Card } from '../../images/icon-components/main-set/card/24.svg'

import { ReactComponent as Transfer } from '../../images/icon-components/main-set/transfer/transfer.svg'
import { ReactComponent as Money } from '../../images/icon-components/main-set/money/money.svg'

import { ReactComponent as MenuS } from '../../images/icon-components/main-set/menu/16.svg'
import { ReactComponent as MenuM } from '../../images/icon-components/main-set/menu/24.svg'
import { ReactComponent as MenuL } from '../../images/icon-components/main-set/menu/32.svg'

import { ReactComponent as Designation } from '../../images/icon-components/main-set/designation/designation.svg'

import { ReactComponent as LineS } from '../../images/icon-components/main-set/line/s/line.svg'
import { ReactComponent as LineM } from '../../images/icon-components/main-set/line/m/line.svg'
import { ReactComponent as LineL } from '../../images/icon-components/main-set/line/l/line.svg'

import { ReactComponent as BarsS } from '../../images/icon-components/main-set/bars/s/bars.svg'
import { ReactComponent as BarsM } from '../../images/icon-components/main-set/bars/m/bars.svg'
import { ReactComponent as BarsL } from '../../images/icon-components/main-set/bars/l/bars.svg'

import { ReactComponent as Settings } from '../../images/icon-components/main-set/settings/24.svg'

import { ReactComponent as InputS } from '../../images/icon-components/main-set/input/16.svg'
import { ReactComponent as InputM } from '../../images/icon-components/main-set/input/24.svg'
import { ReactComponent as InputL } from '../../images/icon-components/main-set/input/32.svg'

import { ReactComponent as OutputS } from '../../images/icon-components/main-set/output/16.svg'
import { ReactComponent as OutputM } from '../../images/icon-components/main-set/output/24.svg'
import { ReactComponent as OutputL } from '../../images/icon-components/main-set/output/32.svg'

import { ReactComponent as ZipS } from '../../images/icon-components/main-set/zip/16.svg'
import { ReactComponent as ZipM } from '../../images/icon-components/main-set/zip/24.svg'
import { ReactComponent as ZipL } from '../../images/icon-components/main-set/zip/32.svg'

import { ReactComponent as UnZipS } from '../../images/icon-components/main-set/unzip/16.svg'
import { ReactComponent as UnZipM } from '../../images/icon-components/main-set/unzip/24.svg'
import { ReactComponent as UnZipL } from '../../images/icon-components/main-set/unzip/32.svg'

import { ReactComponent as TransactionNew } from '../../images/icon-components/main-set/transaction/new.svg'
import { ReactComponent as TransactionPaid } from '../../images/icon-components/main-set/transaction/paid.svg'
import { ReactComponent as TransactionPending } from '../../images/icon-components/main-set/transaction/pending.svg'
import { ReactComponent as TransactionCanceled } from '../../images/icon-components/main-set/transaction/canceled.svg'

import { ReactComponent as ThumbUpS } from '../../images/icon-components/main-set/thumb-up/16.svg'
import { ReactComponent as ThumbUpM } from '../../images/icon-components/main-set/thumb-up/24.svg'
import { ReactComponent as ThumbUpL } from '../../images/icon-components/main-set/thumb-up/32.svg'

import { ReactComponent as GetUniqS } from '../../images/icon-components/main-set/getuniq/s.svg'
import { ReactComponent as GetUniqM } from '../../images/icon-components/main-set/getuniq/m.svg'
import { ReactComponent as GetUniqL } from '../../images/icon-components/main-set/getuniq/l.svg'

import { ReactComponent as YandexS } from '../../images/icon-components/main-set/yandex/s.svg'
import { ReactComponent as YandexM } from '../../images/icon-components/main-set/yandex/m.svg'
import { ReactComponent as YandexL } from '../../images/icon-components/main-set/yandex/l.svg'

import { ReactComponent as MessageS } from '../../images/icon-components/main-set/message/s.svg' //TODO Deprecated
import { ReactComponent as MessageM } from '../../images/icon-components/main-set/message/m.svg' //TODO Deprecated
import { ReactComponent as MessageL } from '../../images/icon-components/main-set/message/l.svg' //TODO Deprecated

import { ReactComponent as Messages } from '../../images/icon-components/main-set/messages/24.svg'

import { ReactComponent as Cat } from '../../images/icon-components/emoji/cat.svg'
import { ReactComponent as Hand } from '../../images/icon-components/emoji/hand.svg'
import { ReactComponent as Shocked } from '../../images/icon-components/emoji/shocked.svg'
import { ReactComponent as HadLove } from '../../images/icon-components/emoji/hadlove.svg'
import { ReactComponent as Fire } from '../../images/icon-components/emoji/fire.svg'
import { ReactComponent as FingerUp } from '../../images/icon-components/emoji/finger-up.svg'
import { ReactComponent as Smart } from '../../images/icon-components/emoji/smart.svg'
import { ReactComponent as Sad } from '../../images/icon-components/emoji/sad.svg'
import { ReactComponent as InLove } from '../../images/icon-components/emoji/inlove.svg'
import { ReactComponent as Wow } from '../../images/icon-components/emoji/wow.svg'
import { ReactComponent as Think } from '../../images/icon-components/emoji/think.svg'
import { ReactComponent as Ok } from '../../images/icon-components/emoji/ok.svg'

import { ReactComponent as FlagRU } from '../../images/icon-components/flags/ru.svg'
import { ReactComponent as FlagEN } from '../../images/icon-components/flags/us.svg'
import { ReactComponent as FlagCN } from '../../images/icon-components/flags/cn.svg'

import { ReactComponent as Gramophone } from '../../images/icon-components/main-set/gramophone/24.svg'

import { ReactComponent as VisaIcon } from '../../images/icon-components/payment-systems/visa.svg'
import { ReactComponent as MirIcon } from '../../images/icon-components/payment-systems/mir.svg'
import { ReactComponent as MasterCardIcon } from '../../images/icon-components/payment-systems/master-card.svg'

import {
  ReactComponent as FlagS,
  ReactComponent as FlagM,
  ReactComponent as FlagL,
} from '../../images/icon-components/main-set/flag/24.svg'

import { ReactComponent as Check } from '../../images/icon-components/main-set/check/16.svg'
import { ReactComponent as Edit } from '../../images/icon-components/main-set/edit/16.svg'
import { ReactComponent as InboxArchiveS } from '../../images/icon-components/main-set/inbox-archive/16.svg'
import { ReactComponent as InboxUploadS } from '../../images/icon-components/main-set/inbox-upload/16.svg'
import { ReactComponent as Logout } from '../../images/icon-components/main-set/log-out/16.svg'
import { ReactComponent as Lock } from '../../images/icon-components/main-set/lock/24.svg'
import { ReactComponent as ShieldDelete } from '../../images/icon-components/main-set/shield-delete/20.svg'
import { ReactComponent as ShieldCheck } from '../../images/icon-components/main-set/shield-check/20.svg'
import { ReactComponent as Apple } from '../../images/icon-components/main-set/apple/24.svg'
import { ReactComponent as Android } from '../../images/icon-components/main-set/android/24.svg'
import { ReactComponent as EyeVisible } from '../../images/icon-components/main-set/eye-visible/24.svg'
import { ReactComponent as EyeHidden } from '../../images/icon-components/main-set/eye-hidden/24.svg'
import { ReactComponent as Profile } from '../../images/icon-components/main-set/profile/24.svg'
import { ReactComponent as TimeMoney } from '../../images/icon-components/main-set/time-money/24.svg'
import { ReactComponent as TimeCredit } from '../../images/icon-components/main-set/time-credit/24.svg'
import { ReactComponent as TimeClock } from '../../images/icon-components/main-set/time-clock/24.svg'
import { ReactComponent as Trash } from '../../images/icon-components/main-set/trash/24.svg'
import { ReactComponent as Minus } from '../../images/icon-components/main-set/minus/24.svg'
import { ReactComponent as Key } from '../../images/icon-components/main-set/key/24.svg'
import { ReactComponent as Union } from '../../images/icon-components/main-set/union/24.svg'
import { ReactComponent as Other } from '../../images/icon-components/main-set/other/24.svg'
import { ReactComponent as ArrowLineRight } from '../../images/icon-components/main-set/arrow-line-right/24.svg'
import { ReactComponent as ArrowLineLeft } from '../../images/icon-components/main-set/arrow-line-left/24.svg'
import { ReactComponent as InfoStyle2Circle } from '../../images/icon-components/main-set/info-style-2-circle/16.svg'
import { ReactComponent as PauseCircle } from '../../images/icon-components/main-set/pause-circle/24.svg'

import { ReactComponent as SortUpDown } from '../../images/icon-components/main-set/sort/up-down.svg'
import { ReactComponent as SortDownUp } from '../../images/icon-components/main-set/sort/down-up.svg'
import { ReactComponent as SortAll } from '../../images/icon-components/main-set/sort/all.svg'

import { ReactComponent as NewLabel } from '../../images/icon-components/main-set/new-label/40.svg'
import { ReactComponent as Rotate } from '../../images/icon-components/main-set/rotate/24.svg'
import { ReactComponent as Play } from '../../images/icon-components/main-set/play/24.svg'
import { ReactComponent as Calculator } from '../../images/icon-components/main-set/calculator/24.svg'

const iconConfig = {
  'arrow-up': { s: ArrowUpS, m: ArrowUpM, l: ArrowUpL },
  'arrow-rounded': ArrowRounded,
  rub: { s: RUBS, m: RUBM, l: RUBL },
  usd: { s: USDS, m: USDM, l: USDL },
  eur: { s: EURS, m: EURM, l: EURL },
  'arrow-down': { s: ArrowDownS, m: ArrowDownM, l: ArrowDownL },
  'arrow1-left': { s: Arrow1LeftS, m: Arrow1LeftM, l: Arrow1LeftL },
  'arrow1-right': { s: Arrow1RightS, m: Arrow1RightM, l: Arrow1RightL },
  'arrow1-down': { s: Arrow1DownS, m: Arrow1DownM, l: Arrow1DownL },
  'arrow2-big': { s: Arrow2BigS, m: Arrow2BigM, l: Arrow2BigL },
  'arrow2-small': { s: Arrow2SmallS, m: Arrow2SmallM, l: Arrow2SmallL },
  'arrow-lineup': ArrowLineUp,
  'arrow-linedown': ArrowLineDown,
  'sort-all': SortAll,

  'arrow-left': { s: ArrowLeft, m: ArrowLeft, l: ArrowLeft },
  'arrow-right': { s: ArrowRight, m: ArrowRight, l: ArrowRight },
  'arrow-previous': { s: ArrowPrevious, m: ArrowPrevious, l: ArrowPrevious },
  'arrow-next': { s: ArrowNext, m: ArrowNext, l: ArrowNext },

  avatar1: { s: Avatar1S, m: Avatar1M, l: Avatar1L },
  avatar2: { s: Avatar2S, m: Avatar2M, l: Avatar2L },
  attach: { s: AttachS, m: AttachM, l: AttachL },
  photo: { s: PhotoS, m: PhotoM, l: PhotoL },
  smile: { s: SmileS, m: SmileM, l: SmileL },
  back: Back,
  bell: Bell,
  bonus: Bonus,
  burger: Burger,
  calendar: Calendar,
  category: Category,
  checkmark1: Checkmark1,
  checkmark2: { s: Checkmark2S, m: Checkmark2M, l: Checkmark2L },
  clients: { s: ClientsS, m: ClientsM, l: ClientsL },
  close: { s: CloseS, m: CloseM, l: CloseL },
  comments: { s: CommentsS, m: CommentsM, l: CommentsL },
  'copy-link': { s: CopyLinkS, m: CopyLinkM, l: CopyLinkL },
  copy: { s: CopyM, m: CopyM, l: CopyM },
  doc: Doc,
  dot: Dot,
  download: Download,
  calculator: Calculator,
  card: { s: Card, m: Card, l: Card },
  'dropdown-menu': { s: DropdownMenuS, m: DropdownMenuM, l: DropdownMenuL },
  flag: { s: FlagS, m: FlagM, l: FlagL },
  filter: Filter,
  filter2: { s: Filter2S, m: Filter2M, l: Filter2L },
  'file-xls': FileXls,
  input: { s: InputS, m: InputM, l: InputL },
  output: { s: OutputS, m: OutputM, l: OutputL },
  lightning: Lightning,
  like: { s: LikeS, m: LikeM, l: LikeL },
  list: { s: ListS, m: ListM, l: ListL },
  logo: { s: LogoS, m: LogoM, l: LogoL, xl: LogoXL },
  'my-agency': { s: MyAgencyS, m: MyAgencyM, l: MyAgencyL },
  minus: { s: Minus, m: Minus, l: Minus },
  'new-label': NewLabel,
  orders: { s: OrdersS, m: OrdersM, l: OrdersL },
  pen: { s: PenS, m: PenM, l: PenL },
  platform: Platform,
  play: Play,
  plus: Plus,
  proxy: { s: ProxyS, m: ProxyM, l: ProxyL },
  rotate: Rotate,
  question: { s: QuestionS, m: QuestionM, l: QuestionL },
  information: { s: InformationS, m: InformationM, l: InformationL },
  delete: { s: DeleteS, m: DeleteM, l: DeleteL },
  refresh: Refresh,
  search: Search,
  spinner: Spinner,
  share: { s: ShareS, m: ShareM, l: ShareL },
  star: Star,
  'stats-1': { s: Stats1S, m: Stats1M, l: Stats1L },
  'stats-2': Stats2,
  designation: Designation,
  transfer: Transfer,
  menu: { s: MenuS, m: MenuM, l: MenuL },
  money: Money,
  user: User,
  users: Users,
  views: { s: ViewsS, m: ViewsM, l: ViewsL },
  'status-ok': StatusOk,
  'status-on': { s: StatusOnS, m: StatusOnM, l: StatusOnL },
  'status-pause': { s: StatusPauseS, m: StatusPauseM, l: StatusPauseL },
  'status-blocked': { s: StatusBlockedS, m: StatusBlockedM, l: StatusBlockedL },
  'status-finished': {
    s: StatusFinishedS,
    m: StatusFinishedM,
    l: StatusFinishedL,
  },
  'status-archive': { s: StatusArchiveS, m: StatusArchiveM, l: StatusArchiveL },

  'status active': StatusActiveRound,
  'status pause': StatusPauseRound,
  'status pause-circle': StatusPauseCircle,
  'status block': StatusBlockRound,
  'status error': StatusErrorRound,
  'status warning': StatusWarningRound,
  'status warning2': StatusWarningRound2,
  'status done': Done,
  'status stop': StatusStopRound,
  'status read': StatusReadRound,

  'transaction new': TransactionNew,
  'transaction pending': TransactionPending,
  'transaction paid': TransactionPaid,
  'transaction canceled': TransactionCanceled,
  'thumb-up': { s: ThumbUpS, m: ThumbUpM, l: ThumbUpL },

  line: { s: LineS, m: LineM, l: LineL },
  message: { s: MessageS, m: MessageM, l: MessageL }, //TODO Deprecated
  messages: Messages,
  bars: { s: BarsS, m: BarsM, l: BarsL },
  settings: Settings,
  getuniq: { s: GetUniqS, m: GetUniqM, l: GetUniqL },
  yandex: { s: YandexS, m: YandexM, l: YandexL },
  zip: { s: ZipS, m: ZipM, l: ZipL },
  unzip: { s: UnZipS, m: UnZipM, l: UnZipL },

  //emoji
  'emoji-cat': Cat,
  'emoji-hand': Hand,
  'emoji-shocked': Shocked,
  'emoji-hadlove': HadLove,
  'emoji-fire': Fire,
  'emoji-fingerup': FingerUp,
  'emoji-smart': Smart,
  'emoji-sad': Sad,
  'emoji-inlove': InLove,
  'emoji-wow': Wow,
  'emoji-think': Think,
  'emoji-ok': Ok,

  //flags
  'flag-ru': FlagRU,
  'flag-en': FlagEN,
  'flag-cn': FlagCN,

  gramophone: Gramophone,

  'ps-visa': VisaIcon,
  'ps-mir': MirIcon,
  'ps-mc': MasterCardIcon,

  //new icon set

  edit: { s: Edit, m: Edit, l: Edit },
  check: { s: Check, m: Check, l: Check },
  'inbox-archive': { s: InboxArchiveS, m: InboxArchiveS, l: InboxArchiveS },
  'inbox-upload': { s: InboxUploadS, m: InboxUploadS, l: InboxUploadS },
  logout: { s: Logout, m: Logout, l: Logout },
  lock: { s: Lock, m: Lock, l: Lock },
  'shield-delete': { s: ShieldDelete, m: ShieldDelete, l: ShieldDelete },
  'shield-check': { s: ShieldCheck, m: ShieldCheck, l: ShieldCheck },
  apple: { s: Apple, m: Apple, l: Apple },
  android: { s: Android, m: Android, l: Android },
  'eye-visible': { s: EyeVisible, m: EyeVisible, l: EyeVisible },
  'eye-hidden': { s: EyeHidden, m: EyeHidden, l: EyeHidden },
  profile: { s: Profile, m: Profile, l: Profile },
  'time-money': TimeMoney,
  'time-credit': TimeCredit,
  'time-clock': TimeClock,
  trash: Trash,
  key: Key,
  union: Union,
  other: Other,
  'arrow-line-right': ArrowLineRight,
  'arrow-line-left': ArrowLineLeft,
  'info-style-2-circle': InfoStyle2Circle,
  'pause-circle': PauseCircle,

  'sort-up-down': { s: SortUpDown, m: SortUpDown, l: SortUpDown },
  'sort-down-up': { s: SortDownUp, m: SortDownUp, l: SortDownUp },
}

export default iconConfig
